// components/layout/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer style={{ padding: '1rem', backgroundColor: '#f8f8f8', marginTop: '2rem' }}>
      <p>© 2025 Premier Granites. All rights reserved.</p>
    </footer>
  );
};

export default Footer;